import SmsLink from './SmsLink';

export default SmsLink;
